import React, {useEffect, useState} from "react";
import Widget from "../../../components/widget";
import EnigooButton from "../../../MyComponent/EnigooButton";
import {FiCheck, FiEdit, FiPlus} from 'react-icons/fi'
import {apiGetUserAdmin, apiVerifyUserAdminManually} from "./Actions";
import {EnigooLoader} from "../../../MyComponent/EnigooLoader";
import EnigooBreadcrumbs from "../../../MyComponent/EnigooBreadcrumbs";
import VerifyRights from "../../VerifyRights";
import {useTranslation} from "react-i18next";
import EnigooTablev2 from "../../../MyComponent/EnigooTablev2";
import EnigooActiveField from "../../../MyComponent/EnigooActiveField";
import EnigooToolTip from "../../../MyComponent/EnigooToolTip";
import CogoToast from "cogo-toast";

const AdminUser = () => {
    let [data, setData] = useState([])
    let [loading, setLoading] = useState(false)
    let [errorMessage, setErrorMessage] = useState(null);
    let [verfiing, setVerfiing] = useState(false);

    const {t, i18n} = useTranslation()

    useEffect(() => {
        getAdmin()
    }, []);

    const getAdmin = () => {
        setLoading(true)
        apiGetUserAdmin((data) => {
            setData(data);
            setLoading(false);
            setErrorMessage(null);
        }, error => {
            setLoading(false);
            setErrorMessage(t("adminUser.loadingError"))
        })
    }

    const verifyManually = (row) => {
        setVerfiing(true);
        apiVerifyUserAdminManually(row.original.id, (data) => {
            row.original.verified = true;
            setVerfiing(false);
        },(error)=>{
            CogoToast.error(t("adminUser.verfiingError"))
            setVerfiing(false);
        })
    }

    const columns = React.useMemo(() => [
        {header: t('basics.email'), id: "login", accessorKey: 'login'},
        {header: t('basics.firstname') + " " + t("basics.lastname"), id: "name", accessorKey: 'name'},
        {header: t('adminUser.lastAction'), id: "lastAction", accessorKey: 'lastAction'},
        {
            header: t('adminUser.active'), id: "active",
            cell: ({row}) => {
                return <EnigooActiveField value={row.original.active}/>
            }
        },
        {
            header: t("adminUser.verified"), id: "verified",
            cell: ({row}) => {
                return <EnigooActiveField value={row.original.verified}/>
            }
        },
        {
            header: t('basics.options'), id: "options",
            cell: ({row}) => {
                return <div className={"flex flex-row space-x-1"}>
                    <EnigooButton icon={<FiEdit/>} link={"admin-user/detail/" + row.original.id}
                                  toolTip={t("rights.edit")} toolTipPosition={"right"} _key={"_tooltip_admin_user_edit_" + (row.original.id)}/>
                    <VerifyRights onlyForManageUser={true}>
                        {
                            !row.original.verified &&
                            <EnigooButton icon={<FiCheck/>}  loading={verfiing}
                                          onClick={()=>{verifyManually(row)}}
                                          toolTip={t("adminUser.verifyManually")}
                                          toolTipPosition={"right"}
                                          _key={"_tooltip_admin_user_verify_" + (row.original.id)}/>
                        }
                    </VerifyRights>
                </div>
            }
        }
    ], [i18n.language]);

    const tableData = React.useMemo(() => data, [data]);

    const _renderBody = () => {
        if (loading) return <EnigooLoader text={t("adminUser.loading")}/>
        if (errorMessage) return <div>{errorMessage}</div>
        if (!data) return null;
        if (data) return <EnigooTablev2 data={tableData} columns={columns} paginated={false} selectable={false}/>
    }

    return (
        <>
            <EnigooBreadcrumbs
                right={<VerifyRights page={"adminUser"} action={"createAdminUser"}> <EnigooButton
                    link={"/admin-user/create"} icon={<FiPlus/>} text={t("basics.add")}/></VerifyRights>}/>
            <Widget>
                {_renderBody()}
            </Widget>
        </>
    )
}

export default AdminUser;
